import { Nullable } from 'interfaces/Nullable.ts';
import { QueryState } from '@/common/enum';
import { IUserPortal } from 'interfaces/UserAccountInfo.interface.ts';
import SitePermissionTypes from '@/common/enum/SitePermissionTypes.ts';

export type AuthTokenTypes = {
  queryState: QueryState;
  token: Nullable<string>;
  tokenVerification: Nullable<IUserPortal>;
  userId: Nullable<number>;
  accessType: Nullable<SitePermissionTypes>;
  error: Nullable<string>;
  username: Nullable<string>;
  /**
   * Expiry of the Cognito ID token that carried this session, in epoch SECONDS.
   * The Palmetto access token itself is opaque, so the ID token's `exp` is the
   * only client-visible signal that the session is about to die. Null means
   * unknown, which is treated as still-valid.
   */
  tokenExpiresAt: Nullable<number>;
};

export const AuthTokenInitialState: AuthTokenTypes = {
  queryState: QueryState.UNDEFINED,
  token: null,
  tokenVerification: null,
  userId: null,
  accessType: null,
  error: null,
  username: null,
  tokenExpiresAt: null,
};
